/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import DelayAnalysisRoomInitState from "../../../rooms/DelayAnalysisRoom/state"
import { DELAY_ANALISYS_ROOM } from "../../../rooms/RoomNameConstants";

const initialState = { ...DelayAnalysisRoomInitState };

const delayAnalysisRoomSlice = createSlice({
    name: DELAY_ANALISYS_ROOM,
    initialState: initialState,
    reducers: {
        setJobstreamData: (state, action) => {
            const { jobId, field, data } = action.payload

            state.jobstreamData[field][jobId] = data
        },
        setJobstream: (state, action) => {
            state.jobstream = action.payload
        },
        setIsPanelOpen: (state, action) => {
            state.isPanelOpen = action.payload
        },
        setGraph: (state, action) => {
            state.graph = action.payload
        },
        resetInitialDelayAnalysisRoom: (state) => {
            Object.assign(state, initialState)
        },
        loadRemoteDelayAnalysisRoom: (state, action) => {
            Object.assign(state, action.payload)
        }

    }
});

export const {
    setGraph,
    setIsPanelOpen,
    setJobstream,
    setJobstreamData,
    resetInitialDelayAnalysisRoom,
    loadRemoteDelayAnalysisRoom
} = delayAnalysisRoomSlice.actions;

export default delayAnalysisRoomSlice;
